import { DockPosition, IViewConfig } from "smarthub-common";
import { IProps } from "./props";

export const viewConfig = ({ position }: IProps): IViewConfig => ({
  mode: "chat",
  main: {
    trapFocus: false,
    initialPanel: {
      condition: "use-first",
      visible: false,
    },
    dockPositions: {
      preferred: "left",
      options: [],
    },
    dockSizes: {
      sm: {
        preferred: "full",
        overlay: false,
        full: 12,
        wide: 12,
        split: 12,
        narrow: 12,
        asside: 12,
      },
    },
  },
  chat: {
    initialPanel: {
      id: "panel.chat",
      visible: true,
    },
    dockPositions: {
      preferred: position?.length ? (position as DockPosition) : "right",
      options: ["left", "right"],
    },
    dockSizes: {
      sm: {
        preferred: "narrow",
        full: 12,
        wide: 12,
        split: 12,
        narrow: 12,
        asside: 12,
      },
      lg: {
        wide: 8,
        split: 6,
        narrow: 6,
        asside: 6,
      },
      lgx: {
        wide: 7,
        narrow: 5,
        asside: 5,
      },
      xl: {
        full: 8,
        wide: 8,
        narrow: 4,
        asside: 4,
      },
      xxl: {
        narrow: 3,
        asside: 3,
      },
    },
  },
  page: {
    visibility: "auto",
    dockPositions: {
      preferred: "right",
      options: [],
    },
    dockSizes: {
      sm: {
        preferred: "full",
        full: 12,
        wide: 12,
        split: 12,
        narrow: 12,
        asside: 12,
      },
      lg: {
        wide: 8,
        split: 6,
        narrow: 6,
        asside: 6,
      },
      lgx: {
        wide: 7,
        narrow: 5,
        asside: 7,
      },
      xl: {
        full: 8,
        wide: 8,
        narrow: 4,
        asside: 8,
      },
    },
  },
});
